// extracted by mini-css-extract-plugin
export default {"header":"managers_header__2Zna-","header__text":"managers_header__text__MZyn2","header__addButtonText":"managers_header__addButtonText__ZB1mY"};